<template>
  <div>
    <simulator-header />
    <main role="main">
      <slot />
    </main>
  </div>
  <subscription-footer />
</template>
